import _ from 'lodash'
import { Map, List } from 'immutable'
import { getPreviewDynamicData } from './projectAxios'

export const setVisibilityOfSFMappingElem = (sfMapping, items, isHide, isOnload, retState, dispatch) => {
  let sfItems = []
  let hashProcessing = {}
  try {
    if (isHide && retState) {
      retState.getIn(['sfActions', 'params'], List()).map((row) => {
        if (row && row.get('items')) {
          row.get('items', List()).map((item) => {
            if (item && item.get('value')) {
              hashProcessing[item.get('value')] = true
            }
          })
        }
      })
      retState.getIn(['query', 'list'], List()).map((row) => {
        if (row && row.get('list')) {
          row.get('list', List()).map((item) => {
            if (item && item.get('value')) {
              hashProcessing[item.get('value')] = true
            }
          })
        }
      })
    }
  } catch (err) {
    console.error(err)
  }
  if (isHide && !isOnload) {
    _.each(items, function (item) {
      if (item && item.value && sfMapping[item.value] && !hashProcessing[item.value]) {
        sfItems.push(sfMapping[item.value])
      }
    })
  } else {
    _.each(items, function (item, uid) {
      if (!isHide) {
        if (window && window.isDisableChangeCart == uid) {
          window.isDisableChangeCart = null
        }
      }
      if (uid && sfMapping[uid] && !hashProcessing[uid]) {
        sfItems.push(sfMapping[uid])
      }
    })
  }
  let RepeatedStripsID = retState.getIn(['project', 'Settings', 'RepeatedStripsID'], List())
  if (List.isList(RepeatedStripsID)) {
    RepeatedStripsID = RepeatedStripsID.toJS()
  } else {
    RepeatedStripsID = []
  }
  let gridElements = []
  let recursiveParseSFItems = function (list) {
    _.each(list, function (sfItem) {
      try {
        const found = _.find(sfItem.fields, { group: 'smartv' })
        if (found) {
          const isUserSignIn = Boolean(getPreviewDynamicData().user || getPreviewDynamicData().messageValue)
          if (!isUserSignIn) return true
        }
      } catch (err) {
        console.error('err', err)
      }
      if (sfItem && sfItem.gridFields) {
        _.each(sfItem.gridFields, function (field) {
          if (field) {
            field = String(field).split('#-#')
            if (field[1]) {
              field = String(field[1]).split(':')
              if (field[1]) {
                if (_.includes(RepeatedStripsID, field[1])) {
                  if (
                    !['select', 'multiselect'].includes(
                      retState.getIn(['pages', retState.get('page'), 'Props', 'elements', field[2], 'props', 'control'])
                    ) &&
                    gridElements.indexOf(field[1]) == -1
                  ) {
                    gridElements.push(field[2])
                  }
                } else if (gridElements.indexOf(field[1]) == -1) {
                  gridElements.push(field[1])
                }
              }
            }
          }
        })
      }

      if (sfItem && sfItem.childrens) {
        recursiveParseSFItems(sfItem.childrens)
      }
    })
  }

  recursiveParseSFItems(sfItems)

  if (dispatch) {
    let loadingElements = {}
    _.each(gridElements, function (fieldUID) {
      loadingElements[fieldUID] = isHide
    })
    dispatch({
      type: 'SET_PAGE_LOADING_ELEMENTS',
      payload: {
        elements: loadingElements,
      },
    })
  } else if (retState) {
    let loadingElements = retState.get('isLoadingElements', Map())
    _.each(gridElements, function (fieldUID) {
      loadingElements = loadingElements.set(fieldUID, isHide)
    })
    _.map(items, (val, key) => {
      if (sfMapping[key]) {
        const isSubComp = sfMapping[key]?.elemUID?.includes?.('##')
        if (isSubComp && sfMapping[key].elemUID) {
          const [parendId] = String(sfMapping[key].elemUID).split('##')
          loadingElements = loadingElements.set(`${parendId}-subComp`, isHide)
        }
      }
    })
    retState = retState.set('isLoadingElements', loadingElements)

    return retState
  } else {
    return false
  }
}
